module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ScreenLayout', {
    ref: "screenLayout",
    attrs: {
      "title": 'Download Contacts - ' + _vm.officeName,
      "rightVisible": true
    }
  }, [_c('template', {
    slot: "left"
  }, [_c('div', {
    staticStyle: {
      "padding": "60px"
    }
  }, [_c('v-icon', {
    attrs: {
      "size": "120",
      "color": "#ddd"
    }
  }, [_vm._v("arrow_circle_down")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "pa-5"
  }, [_vm._v("\n            Contacts will be downloaded to CSV (comma separated) which will open in Excel."), _c('br'), _c('br'), _vm._v("\n            \n            You have " + _vm._s(_vm.contacts.length) + " contacts\n            "), _c('br'), _c('br'), _vm._v(" "), _c('vue-json-to-csv', {
    attrs: {
      "json-data": _vm.contacts,
      "labels": {
        firstName: {
          title: 'First name'
        },
        lastName: {
          title: 'Last name'
        },
        mobile: {
          title: 'Mobile'
        },
        email: {
          title: 'Email'
        },
        address: {
          title: 'Address'
        },
      },
      "csv-title": "Contacts"
    }
  }, [_c('v-btn', {
    staticClass: "primary",
    attrs: {
      "rounded": ""
    }
  }, [_vm._v("\n    Download\n  ")])], 1)], 1), _vm._v(" "), _c('template', {
    slot: "right"
  }, [_vm._v("\n \n            ")])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c708a500"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DownloadPage.vue
// module id = 2655
// module chunks = 1